import styled from 'styled-components';

import {
  Flex,
  Text,
} from 'web-styled';

export const Search = styled(Flex).attrs({
  flex: '0 0 68px',
  align: 'center',
})`
  width: 100%;
  padding: 0 15px;

  & > div {
    width: 100%;
  }
`;

export const Items = styled(Flex).attrs({
  flex: '0 0 25%',
  column: true,
})`
  height: 100%;
  min-width: 215px;
  width: 360px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f9f9f9;
  border-right: 2px solid rgba(40, 45, 48, 0.1);
  color: #797979;
  box-sizing: border-box;
`;

interface ItemProp {
  hasUnread: boolean
  selected: boolean
}

export const Item = styled(Flex).attrs({
  width: '100%',
  align: 'center',
  spacing: 10,
  shrink: 0,
})<ItemProp>`
  color: #797979;
  padding: 10px;
  padding-left: 20px;
  background-color: #fff;
  position: relative;
  border-bottom: 1px solid rgba(40, 45, 48, 0.1);
  cursor: pointer;

  ${props => props.hasUnread && `
    font-weight: bold;

    &:before {
      content: '';
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: ${props.theme.colors.primary};
      position: absolute;
      left: 8px;
      bottom: 27px;
    }
  `}

  ${props => (props.selected ? `
    color: #fff;
    background-color: ${props.theme.colors.primary};
  ` : `
    &:hover {
      background: #fbfbfb;
    }
  `)}
`;

export const ItemText = styled(Text)`
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const Remove = styled.span`
  position: absolute;
  top: 0px;
  right: -15px;
  visibility: hidden;
  width: 10px;
  height: 10px;
  cursor: pointer;
`;
